import { render } from "./EmployeeLicense.vue?vue&type=template&id=c574ae94&scoped=true"
import script from "./EmployeeLicense.vue?vue&type=script&lang=js"
export * from "./EmployeeLicense.vue?vue&type=script&lang=js"

import "./EmployeeLicense.vue?vue&type=style&index=0&id=c574ae94&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c574ae94"]])

export default __exports__